import posed from 'react-pose';

const Item = posed.div({
  open: { y: 0, opacity: 1 },
  closed: { y: 20, opacity: 0 },
});

export default Item;



// WEBPACK FOOTER //
// ./src/components/Item/index.js